import React, { useEffect, useState } from 'react'
import BugDetails from './BugDetails'
import { Table } from 'antd'
import { fetchBugs, fetchNextBugs, updateDoc } from '../../../firebase/utils'
import { Card, Container } from 'reactstrap'
import { Breadcrumbs, Btn } from '../../../AbstractElements'
import { useVT } from 'virtualizedtableforantd4'
import moment from 'moment'
import SeachBar from '../../UiKits/SearchBar'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router'
import { addSearchParams, getSearchParams } from '../../../utils'

const BugReport = () => {
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [lastDoc, setlastDoc] = useState(null)
  const [bug, setBug] = useState({
    show: false,
    details: null
  })
  const [bugReports, setBugReports] = useState([])
  const location = useLocation();

  const debug = false
  const [vt] = useVT(
    () => ({
      onScroll: ({ isEnd }) => {
        if (isEnd) {
          fetchBugReports('next')
        }
      },
      scroll: { y: 500 },
      debug,
    }),
    [lastDoc, bugReports]
  );

  const openBugDetails = (bug) => {
    addSearchParams(location, bug);
    setBug({ show: true, details: bug });
  };

  const checkAndOpenDetails = () => {
    const { isOpenDetails, itemId } = getSearchParams(location);
    if (isOpenDetails && itemId) {
      const selectedBug = bugReports.find((b) => b.id === itemId);
      if (selectedBug) {
        setBug({ show: true, details: selectedBug });
      } else {
        setBug({ show: false, details: null });
      }
    } else {
      setBug({ show: false, details: null });
    }
  }

  useEffect(() => {
    checkAndOpenDetails();
  }, [location.search, bugReports]);

  useEffect(() => {
    window.addEventListener("popstate", checkAndOpenDetails);
    return () => window.removeEventListener("popstate", checkAndOpenDetails);
  }, [bugReports]);

  const resolveBug = async (id, status) => {
    const updatedItem = [...bugReports]
    const bugToUpdate = updatedItem.find((bu) => bu.id === id)
    bugToUpdate.resolved = !bugToUpdate.resolved
    updateDoc('crashErrors', id, {
      resolved: status ? false : true
    })
    toast.success(`Bug Mark as ${status ? 'pending ' : "resolved"}  successfully`)
    setBugReports(updatedItem)
  }

  const bugTableColumnRow = [
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Type",
      dataIndex: "functionName"
    },
    {
      title: 'Report Date',
      dataIndex: "createdAt",
      render: (data) => moment(data.seconds * 1000).format('LLL')
    },
    {
      title: 'Open Bug',
      render: (bug) => <div style={{ display: 'grid', placeItems: "center" }}><Btn attrBtn={{ color: "primary", onClick: () => openBugDetails(bug) }}>Open</Btn></div>
    },
    {
      title: 'Resolve',
      render: (bug) => <div style={{ display: 'grid', placeItems: "center" }}><Btn attrBtn={{ color: bug.resolved ? "primary" : "secondary", onClick: () => resolveBug(bug.id, bug.resolved) }}>{bug.resolved ? 'Mark as pending' : 'Mark as resolved'}</Btn></div>

    }
  ]

  const fetchBugReports = async (direction) => {
    if (direction === 'next') {
      const reports = await fetchNextBugs(lastDoc)
      setBugReports([...bugReports, ...reports.bugs])
      setlastDoc(reports.lastDoc)
    } else {
      const reports = await fetchBugs()
      setBugReports(reports.bugs)
      setlastDoc(reports.lastDoc)

    }
    setLoading(false)
  }

  const filteredBugs = bugReports.filter((bug) => bug.email.toLowerCase().includes(search.toLowerCase()))

  useEffect(() => {
    fetchBugReports()
  }, [])
  return (
    <>
      <Breadcrumbs mainTitle={'Bug Report'} />
      <Container fluid={true} className="dashboard-default">
        <Card className='p-3'>
          <div className='bug-report-search'>
            <SeachBar search={search} setSearch={setSearch} />
          </div>
          <div style={{ marginBottom: '100px' }} className='ant-design-table not-margin'>
            <Table
              loading={loading}
              // rowClassName={(record) => record.banned ? 'banned-student' : ''}
              columns={bugTableColumnRow}
              dataSource={filteredBugs}
              components={vt}
              bordered={true}
              pagination={false}

              scroll={{ y: 800 }}
            />
            {bug.show && <BugDetails bug={bug} setBug={setBug} />}
          </div>
        </Card>
      </Container>
    </>
  )
}

export default BugReport